/*
 * @Description:
 * @Author: zhanghang
 * @Date: 2023-11-14 10:49:13
 * @LastEditors: zhanghang
 * @LastEditTime: 2024-08-21 16:01:17
 */
import dataviewUtils from "_dataview/output/utils/index.js";

import { selectThemeMapList } from "_dataview/output/config/themeList.js";

import { unitValueMap, fontList } from "_dataview/output/config/commonConfig.js";

if (!dsf.dataview) {
  dsf.dataview = {};
}
!(function (global) {
  let $$dataviewConfig = global.$$dataviewConfig || {};

  let { $eventTemplate, $dataviewFonts, $dataviewStyles = [], $dataviewThemes = [], $extendSelectThemeConfig = {}, $extendGis, $eventKeyNames = {} } = $$dataviewConfig;
  //拓展伪代码事件
  dsf.dataview.eventTemplate = $eventTemplate;
  //拓展gis
  dsf.dataview.extendGis = $extendGis;
  //拓展组件依赖事件
  dsf.dataview.eventKeyNames = $eventKeyNames;

  //预留字段
  dsf.dataview.designer = {};

  //字体文件
  dsf.dataview.fonts = fontList;
  let dataviewFonts = $dataviewFonts;
  if (dataviewFonts) {
    dsf.dataview.fonts.push(...dataviewFonts);
  }
  dsf.dataview.designer.fonts = dsf.dataview.fonts;

  //大屏单位
  dsf.dataview.units = unitValueMap;

  if (dsf.dataview.utils) {
    dsf.dataview.utils = dsf.mix(true, {}, dsf.dataview.utils, {
      ...dataviewUtils,
    });
  } else {
    dsf.dataview.utils = dataviewUtils;
  }
  //大屏风格
  dsf.dataview.extendStyle = $dataviewStyles;
  //主题名称分类
  dsf.dataview.selectThemes = dsf.mix(true, [], $dataviewThemes, selectThemeMapList);
  //主题输入组件主题
  // dsf.dataview.selectThemeConfig = import(/* webpackChunkName: "dataview_common_private",webpackMode: "lazy-once" */ "_dataview/output/config/select.js");
  dsf.dataview.extendSelectThemeConfig = $extendSelectThemeConfig;
})(dsf.global || (dsf.global = {}));
